export const ROUTE = {
  HOME: '/',
  ONBOARDING: '/onboarding',
  REMEDIATION: '/remediation',
  COUNTRY_SELECTION: '/onboarding/country-selection',
  LANGUAGE_SELECTION: '/onboarding/language-selection',
  LOGIN: '/onboarding/email-form',
  LOGIN_VERIFY_EMAIL: '/onboarding/email-verification',
  LOGIN_PRE_APPROVED_STATUS: '/onboarding/pre-approved-status',
  PHONE_FORM: '/onboarding/phone-form',
  VERIFY_ID: '/onboarding/id-verification',
  VERIFY_MINOR_ID: '/onboarding/minor-id-verification',
  VERIFY_MINOR_SELFIE: '/onboarding/minor-selfie-verification',
  VERIFY_SELFIE: '/onboarding/selfie-verification',
  VERIFY_MINOR_BIRTH_CERTIFICATE:
    '/onboarding/minor-birth-certificate-verification',
  VERIFY_MINOR_FAMILY_BOOK: '/onboarding/minor-family-book-verification',
  MINOR_BASIC_INFO: '/onboarding/minor-basic-information',
  MINOR_REVIEW_COMPLETE: '/onboarding/minor-review-complete',
  MOBILE_ADOPTION_VERIFY_OTP: '/mobile-adoption/verify-otp',
  MOBILE_ADOPTION_IDENTIFY_CUSTOMER: '/mobile-adoption/identify-customer',
  OPEN_REPUBLIC_SUPER_APP: '/open-republic-super-app',
  ADDRESS_INFORMATION: '/onboarding/address-information',
  THIRD_PARTY_COMPLIANCE_CHECK: '/onboarding/third-party-compliance-check',
  APPLICATION_TYPE_SELECTION: '/onboarding/application-type-selection',
  APPLICATION_TYPE_SELECTION_FAILED:
    '/onboarding/application-type-selection-failed',
  RIGHT_START_COMING_SOON: '/onboarding/right-start-coming-soon',
  BUSINESS_COMING_SOON: '/onboarding/business-coming-soon',
  SHARED_WITH_SOMEONE_ELSE_COMING_SOON:
    '/onboarding/shared-with-someone-else-coming-soon',
  THIRD_PARTY_COMPLIANCE_CHECK_FAILED:
    '/onboarding/third-party-compliance-check-failed',
  SUCCESS: '/onboarding/success',
  ADD_ADULT_DETAIL: '/onboarding/add-adult-detail',
  ADD_ADULT_CONTACT: '/onboarding/add-adult-contact',
  ADD_ADULT_CONTACT_RESULT: '/onboarding/add-adult-contact-result',
  ADD_ADULT_DETAIL_RESULT: '/onboarding/add-adult-detail-result',
  ADD_ADULT_DETAIL_RESULT_FAILED: '/onboarding/add-adult-detail-result-failed',
  AGE_VALIDATION_FAILURE: '/onboarding/age-validation',
  JOINT_ADULT_AGE_VALIDATION_FAILURE: '/onboarding/joint-adult-age-validation',
  MINOR_AGE_VALIDATION_FAILURE: '/onboarding/minor-age-validation',
  NON_RESIDENT_MINOR_REJECTED: '/onboarding/non-resident-minor-rejected',
  CAYMAN_COUNTRY_VALIDATION_FAILURE:
    '/onboarding/cayman-country-resident-validation',
  MINOR_TRIGGERED_BY_ADULT: '/onboarding/minor-triggered-by-adult',
  CAYMAN_THIRD_PARTY_COMPLIANCE_CHECK_FAILED:
    '/onboarding/cayman-third-party-compliance-check-failed',
  BASIC_INFO: '/account/basic-information',
  ACCOUNT_REJECTED: '/account/rejected',
  ACCOUNT_TYPE: '/account/account-type',
  MORE_INFORMATION: '/account/more-information',
  REVIEW_PERSONAL_DETAILS: '/account/review-personal-details',
  UPDATE_PERSONAL_DETAILS: '/account/update-personal-details',
  SESSION_EXPIRED: '/session-expired',
};
